import { Component, Input, OnInit } from "@angular/core";
import { FormBuilder, FormGroup, Validators } from "@angular/forms";
import { NgbActiveModal } from "@ng-bootstrap/ng-bootstrap";
import { ProductsService } from "app/modules/products/products.service";
import { PageService } from "app/services/page-service";
import { environment } from "environments/environment";
import { Observable, of } from "rxjs";
import {
  catchError,
  debounceTime,
  distinctUntilChanged,
  switchMap,
  tap,
} from "rxjs/operators";

@Component({
  selector: "app-extra-addons",
  templateUrl: "./extra-addons.component.html",
  styles: [],
})
export class ExtraAddonsComponent implements OnInit {
  @Input() content: any;
  addOnForm: FormGroup;
  addonCategory = environment.addonCategory;
  curreny = environment.CURRENCY;
  addonType: "";
  submitted = false;
  addonName = "";
  addonSearching = false;
  tax = {};
  addonSearchFailed = false;
  formatter = (x: { name: string }) => x.name;
  tappedAddonPrice = 0;
  constructor(
    public dialogRef: NgbActiveModal,
    private fb: FormBuilder,
    private productService: ProductsService,
    public service :PageService
  ) {}

  ngOnInit(): void {
    this.service.getplatformConfig().then((data) => {
      const platformData = data['Data'];
      this.curreny = platformData && platformData['currency'] ? platformData['currency'] : environment.CURRENCY;
    });
    this.addOnForm = this.fb.group({
      addonName: ["", [Validators.required]],
      sellPrice: [this.tappedAddonPrice, [Validators.required]],
      addonCategory: ["", [Validators.required]],
    });
  }
  categoryChanged() {
    this.addonName = "";
  }
  close() {
    this.dialogRef.close({ success: false });
  }
  autosearchSub = (text$: Observable<string>) =>
    text$.pipe(
      debounceTime(200),
      distinctUntilChanged(),
      tap(() => (this.addonSearching = true)),
      switchMap((term) => {
        const search = {
          name: term,
          category: this.addOnForm.value.addonCategory,
        };
        return this.productService.searchAddon(search).pipe(
          tap(() => (this.addonSearchFailed = false)),
          catchError(() => {
            this.addonSearchFailed = true;
            return of([]);
          })
        );
      }),
      tap(() => (this.addonSearching = false))
    );
  updatePrice() {
    // console.log(this.addonName);
    this.tappedAddonPrice = this.addonName["price"];
    this.tax = this.addonName["tax"];
  }
  get f() {
    return this.addOnForm.controls;
  }
  success() {
    this.submitted = true;
    if (this.addOnForm.invalid) return;
    // console.log(this.addOnForm);
    const addon = this.addOnForm.value;
    addon["addonName"].price = parseInt(this.addOnForm.value.sellPrice);

    this.dialogRef.close({ success: true, addon });
  }
}
